<template>
  <div>
    <commentSearchTransactionList />
  </div>
</template>
<script>
import commentSearchTransactionList from
  '../../../components/tax/Comments/commentSearchTransactionList.vue';

export default {
  name: 'commentSearch',
  data: () => ({

  }),
  components: {
    commentSearchTransactionList,
  },
};
</script>
